import './parent.js';
import './multibox-menu.js';
import './jquery.plugin.js';
import './jquery.manager.js';
import './jquery.multiscroll.js';
import './jquery.banner.js';

jQuery(function($) {
    $('html').kbManager();
});
